import type { BoxSearchLegInterface } from "../flightAirportInterface";

export class BoxSearchLegClass implements BoxSearchLegInterface {
  cityName: string = "";

  citySlug: string = "";

  code: string = "";

  countryName: string = "";

  countrySlug: string = "";

  name: string = "";

  slug: string = "";

  constructor(data?: BoxSearchLegInterface) {
    this.cityName = data?.cityName ?? this.cityName;
    this.citySlug = data?.citySlug ?? this.citySlug;
    this.countryName = data?.countryName ?? this.countryName;
    this.code = data?.code ?? this.code;
    this.countrySlug = data?.countrySlug ?? this.countrySlug;
    this.name = data?.name ?? this.name;
    this.slug = data?.slug ?? this.slug;
  }
}
